






















import { Vue, Component, Prop } from 'vue-property-decorator'
import { PageRuleSortList } from '@/types/newPersion'
import { coverImg } from '@/api/newPersion'
@Component
export default class extends Vue {
  @Prop() route!: string;
  @Prop() pageRuleSortList!: PageRuleSortList[];
  @Prop() btnText!: string;
  @Prop() titleText!: string;

  coverImage = '';
  async created () {
    this.getCoverPageData(this.pageRuleSortList)
  }

  // 获取图片地址
  private async getCoverPageData (list: PageRuleSortList[]) {
    const _id = list[0]?.id
    if (_id) {
      const coverData = await coverImg({ iasPageInfoId: _id })
      this.coverImage = coverData?.data?.prcUrl
    }
  }
}
